import { createIcon } from "@chakra-ui/react";

export const Surprising = createIcon({
  displayName: "Surprising",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#pid8c8rl1a)">
      <path
        fill="#FFBC58"
        d="M2.625 12a9.376 9.376 0 1 0 18.751 0 9.376 9.376 0 0 0-18.751 0zm3.21-3.918A5.473 5.473 0 0 1 9.48 6.375a.314.314 0 0 1 .332.293A.314.314 0 0 1 9.52 7a4.862 4.862 0 0 0-3.23 1.512.314.314 0 0 1-.442.011.314.314 0 0 1-.012-.441zm3.68 2.668a.625.625 0 1 1-1.249 0 .625.625 0 0 1 1.25 0zm-.015 5c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5V17c0 1.379-1.121 2.5-2.5 2.5A2.502 2.502 0 0 1 9.5 17v-1.25zm4.688-9.082a.314.314 0 0 1 .332-.293 5.474 5.474 0 0 1 3.644 1.707.314.314 0 0 1-.012.441.314.314 0 0 1-.441-.011A4.862 4.862 0 0 0 14.48 7a.314.314 0 0 1-.293-.332zm1.578 4.082a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0z"
      />
      <path
        fill="#2B2C3D"
        d="M21.375 12a9.376 9.376 0 1 0-18.752 0 9.376 9.376 0 0 0 18.752 0zM2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0zm11.875 3.75a1.875 1.875 0 0 0-3.75 0V17a1.875 1.875 0 0 0 3.75 0v-1.25zm-4.375 0c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5V17c0 1.379-1.121 2.5-2.5 2.5A2.502 2.502 0 0 1 9.5 17v-1.25zm-1.234-5a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0zm6.875-.625a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25zM9.812 6.668A.314.314 0 0 1 9.52 7a4.862 4.862 0 0 0-3.23 1.512.314.314 0 0 1-.442.011.314.314 0 0 1-.012-.441A5.473 5.473 0 0 1 9.48 6.375a.314.314 0 0 1 .332.293zM14.48 7a.314.314 0 0 1-.293-.332.314.314 0 0 1 .333-.293 5.474 5.474 0 0 1 3.644 1.707.314.314 0 0 1-.012.441.314.314 0 0 1-.441-.011A4.862 4.862 0 0 0 14.48 7z"
      />
    </g>,
    <defs>
      <clipPath id="pid8c8rl1a">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  ],
  defaultProps: {
    "aria-label": "Face with open mouth emoji"
  }
});

export default Surprising;
